import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { CustomerReport } from '@module/analysis/CustomerReport';
import { RequestLog } from '@module/analysis/RequestLog';
import { RequestLogDetails } from '@module/analysis/RequestLogDetails';
import { ThankYou } from '@module/analysis/ThankYou';
import { Forbidden } from '@module/authentication/components/Forbidden';
import Login from '@module/authentication/components/Login';
import Logout from '@module/authentication/components/Logout';
import RequireAuthentication from '@module/authentication/components/RequireAuthentication';
import { SilentRenew } from '@module/authentication/components/SilentRenew';
import { Home, Layout } from '@module/shared';

const ourRoutes: IRouteEntry[] = [
  {
    component: Layout,
    routes: [
      { path: '/Login', component: Login},
      { path: '/Logout', component: Logout},
      { path: '/Forbidden', component: Forbidden},
      { path: '/SilentRenew', component: SilentRenew},
      { path: '/thankyou', component: ThankYou},
      { path: '/customerReport/:requestId', component: CustomerReport},
      { path: '/requests',
        component: RequireAuthentication,
        routes: [
          { path: '/requests/:requestId', component: RequestLogDetails},
          { component: RequestLog },
        ]
      },
      { path: '/', component: Home},
    ]
  }
];

// Common below this point

export default toSwitch(ourRoutes);

function RouteWithSubroutes({ component, routes, exact, path }: IRouteEntry) {
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Route {...{ path, exact }} render={props => renderComponent(props, component, routes)} />
  );
}

function renderComponent(props: any, Component: React.ComponentClass<any>, routes?: IRouteEntry[]): JSX.Element {
  const children: JSX.Element | undefined = routes ? toSwitch(routes) : undefined;

  return (<Component {...props} {...{ children }} />);
}

function toSwitch(routes: IRouteEntry[]) {
  return (
    <Switch>
      {routes.map((r, i) => <RouteWithSubroutes key={i} {...r} />)}
    </Switch>
  );
}

interface IRouteEntry {
  path?: string;
  exact?: boolean;
  component: React.ComponentClass<any>;
  routes?: IRouteEntry[];
}
